'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './sign-in-sheet.routes';

export class SignInSheetComponent {
  constructor($uibModal, DTOptionsBuilder, AttendanceService, dialogs, $compile, $scope) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.AttendanceService = AttendanceService;

    this.dialogs = dialogs;
    this.selectedDate = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

    this.meetingDates = [];
    AttendanceService.getMeetingDates(data => {
      this.meetingDates = data.map(date => {
        return {
          date: date,
          formatted: this.formatDate(date)
        }
      })
    });

    this.getData();

    this.dtInstance = {};
    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('pageLength', 50)
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Attendance Report (' + this.from + ' till ' + this.to + ')'
      },{
        extend: 'csv',
        title: 'Attendance Report (' + this.from + ' till ' + this.to + ')'
      },{
        title: 'Attendance Report (' + this.from + ' till ' + this.to + ')',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print'])
      .withBootstrap();
  }

  getData() {
    this.AttendanceService.getByDate({date: this.selectedDate}, data => {

      this.alreadySignedInToday = data
        .filter(attendance =>  attendance.member && attendance.type == 'member')
        .map(attendance => attendance.member._id);

      if (!this.data)
        this.data = data;
      else {
        this.data = data;
        this.dtInstance.DataTable.draw();
      }
    });
  }

  showNotes(attendance) {
    this.dialogs.notify("Notes", attendance.notes);
  }

  formatDate(inputDate) {
    var date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
      // Months use 0 index

      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    }
  }

  signIn() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      size: 'md',
      animation: true,
      component: 'signInSheetForm',
      resolve: {
        config: function() {
          return {
            alreadySignedInToday: that.alreadySignedInToday
          };
        }
      }
    });

    modalInstance.result.then(_ => {
      that.getData();
    }, _ => {
      that.getData();
    });
  }

  edit(attendance) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      size: 'md',
      animation: true,
      component: 'signInSheetForm',
      resolve: {
        config: function() {
          return {
            attendance: attendance,
            alreadySignedInToday: that.alreadySignedInToday
          };
        }
      }
    });

    modalInstance.result.then(_ => {
      that.getData();
    }, _ => {
      that.getData();
    });
  }

  delete(attendance) {
    var that = this;

    let name = attendance.attendedBy;

    let fullName = (attendance.member) ? attendance.member.firstName + " " + attendance.member.lastName : "Former Member";

    if (attendance.type === 'sub') {
      name = attendance.subName;
      name += " (Sub for " + fullName + ")";
    } else if (attendance.type === 'guest') {
      name += " (Guest of " + fullName + ")";
    }

    var guestText = "<br/><br/><b>" + name + "</b>";

    var dlg = this.dialogs.confirm("Delete Attendance?", "Do you really want to delete the attendance of" + guestText);
    dlg.result.then(() => {
      // OK delete it
      that.AttendanceService.delete({id: attendance._id},
        () => {
          that.getData();
        },
        err => {
          alert("Could not delete attendance");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.signInSheet', [uiRouter])
  .config(routes)
  .component('signInSheet', {
    template: require('./sign-in-sheet.html'),
    controller: SignInSheetComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/attendance/sign-in-sheet/sign-in-sheet.component.js